export default {
  app: {
    giftVoucher: {
      title: 'Dárkový poukaz',
      pageTitle: 'Elixír Tours - Dárkový poukaz',
    },
  },
};
